import axios from "axios";
import { APP_PATH } from "../api/backendPath";

// Create axios instance with auth token
const createAxiosInstance = () => {
  const token = sessionStorage.getItem("usr_1a2b3c");
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

/**
 * Get all lab services/tests (for the services and pricing page)
 * @param {Object} params - Query parameters for filtering
 * @returns {Promise} Response from the API
 */
export const getLabServices = async (params = {}) => {
  try {
    const axiosInstance = createAxiosInstance();
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.search) queryParams.append("search", params.search);
    if (params.category) queryParams.append("category", params.category);
    if (params.testType) queryParams.append("testType", params.testType);
    if (params.status) queryParams.append("status", params.status);

    const response = await axiosInstance.get(
      `${APP_PATH.labServices}?${queryParams.toString()}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching lab services:", error);
    throw error;
  }
};

/**
 * Create a new lab service/test
 * @param {Object} serviceData - Service data object
 * @returns {Promise} Response from the API
 */
export const createLabService = async (serviceData) => {
  try {
    const axiosInstance = createAxiosInstance();
    const response = await axiosInstance.post(
      APP_PATH.labServices,
      serviceData,
    );

    // Check if the response indicates an error even with 201 status
    if (response.data && response.data.status === false) {
      const error = new Error(
        response.data.message || "Failed to create lab service",
      );
      error.response = { data: response.data };
      throw error;
    }

    return response.data;
  } catch (error) {
    console.error("Error creating lab service:", error);
    throw error;
  }
};

/**
 * Update an existing lab service/test
 * @param {string} serviceId - The service ID
 * @param {Object} serviceData - Updated service data
 * @returns {Promise} Response from the API
 */
export const updateLabService = async (serviceId, serviceData) => {
  try {
    const axiosInstance = createAxiosInstance();
    const response = await axiosInstance.put(
      `${APP_PATH.labServices}/${serviceId}`,
      serviceData,
    );

    // Check if the response indicates an error
    if (response.data && response.data.status === false) {
      const error = new Error(
        response.data.message || "Failed to update lab service",
      );
      error.response = { data: response.data };
      throw error;
    }

    return response.data;
  } catch (error) {
    console.error("Error updating lab service:", error);
    throw error;
  }
};

/**
 * Delete a lab service/test
 * @param {string} serviceId - The service ID
 * @returns {Promise} Response from the API
 */
export const deleteLabService = async (serviceId) => {
  try {
    const axiosInstance = createAxiosInstance();
    const response = await axiosInstance.delete(
      `${APP_PATH.labServices}/${serviceId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting lab service:", error);
    throw error;
  }
};
